var ko = require('knockout');
var $ = require('jquery');

ko.components.register('youtube-video', {
  viewModel: require('./youtube-video'),
  template: require('./youtube-video.template')
});

// Attach component to elements with data-attribute
$('[data-youtube-video]').each(function() {
  ko.applyBindings({}, this);
});
